<template>
  <section>
    <div class="form-group">
      <div class="row">
        <div class="col-xs-12 col-sm-6" v-if="showAge">
          <label class="inbox-label ">{{ t("application.age") }}</label>
          <IntegerInput
            v-model="age"
            :fieldTitle="t('application.age', {}, 'zh')"
            fieldname="age"
            name="age"
            min="16"
            max="120"
          />
        </div>
        <div class="col-xs-12 col-sm-6">
          <label class="inbox-label ">{{
            t("application.born_in_hk")
          }}</label
          ><br />
          <div class="radio-group">
            <label class="btn-radio">
              <input
                v-model="bornInHKVal"
                :fieldTitle="t('application.born_in_hk', {}, 'zh')"
                :fieldValue="bornInHKVal"
                name="born-in-hk"
                type="radio"
                value="yes"
                fieldname="bornInHk"
                fieldType="isBornInHK"
                field-single
              />
              {{ t("common.yes") }} </label
            ><label class="btn-radio">
              <input
                v-model="bornInHKVal"
                :fieldTitle="t('application.born_in_hk', {}, 'zh')"
                :fieldValue="bornInHKVal"
                fieldname="bornInHk"
                fieldType="isBornInHK"
                field-single
                name="born-in-hk"
                type="radio"
                value="no"
              />
              {{ t("common.no") }}
            </label>
          </div>
        </div>
        <div class="col-sm-6 col-xs-12">
          <label class="inbox-label">{{ t("application.invitation_code") }}</label>
          <input
              id="invCode-txt"
              v-model="inviteCodeVal"
              :fieldTitle="t('application.invitation_code', {}, 'zh')"
              fieldname="inviteCode"
              name="inviteCode"
              type="text"
              maxlength="300"
              class="form-control"
          />
        </div>
      </div>
    </div>
    <input
      v-if="bornInHKVal =='yes'"
      value="yes"
      type="hidden"
      name="permanentHkid"
      fieldname="permanentHkid"
    />
    <div class="form-group">
      <div class="row">
        <div v-if="bornInHKVal === 'no'"  class="col-xs-12 col-sm-6">
          <label class="inbox-label ">{{
            t("application.permanent_hkid")
          }}</label
          ><br />
          <div class="radio-group">
            <label class="btn-radio">
              <input
                v-model="permanentVal"
                :fieldTitle="t('application.permanent_hkid', {}, 'zh')"
                :fieldValue="permanentVal"
                name="permanent"
                type="radio"
                value="yes"
                fieldname="permanentHkid"
                fieldType="isHKPermanentResident"
                field-single
              />
              {{ t("common.yes") }} </label
            ><label class="btn-radio">
              <input
                v-model="permanentVal"
                :fieldTitle="t('application.permanent_hkid', {}, 'zh')"
                :fieldValue="permanentVal"
                fieldname="permanentHkid"
                fieldType="isHKPermanentResident"
                field-single
                name="permanent"
                type="radio"
                value="no"
              />
              {{ t("common.no") }}
            </label>
          </div>
        </div>
        <div v-if="bornInHKVal === 'no' && permanentVal === 'no'" class="col-xs-12 col-sm-6">
          <label class="inbox-label">{{
            t("application.visa_validity_period")
          }}</label>
          <IntegerInput
            v-model="validityPeriodVal"
            :fieldTitle="t('application.visa_validity_period', {}, 'zh')"
            :label="t('common.year_unit')"
            fieldname="visaValidityPeriod"
            name="validity"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import IntegerInput from "~/components/form/IntegerInput.vue";
export default {
  name: "Identity",
  components: {
    IntegerInput,
  },
  props: {
    bornInHK: {
      type: String,
      default: "",
    },
    permanent: {
      type: String,
      default: "",
    },
    validityPeriod: {
      type: Number,
      default: 0,
    },
    showAge: {
      type: Boolean,
      default: false,
    },
    age: {
      type: Number,
      default: 0,
    },
    inviteCode: {
      type: String,
      default: "",
    },
  },
  data: function () {
    return {
      bornInHKVal: "",
      permanentVal: "",
      validityPeriodVal: 0,
      inviteCodeVal: ""
    };
  },
  computed: {},
  mounted() {
    this.bornInHKVal =
      this.bornInHK || this.$store.state.form.applicantInfo.bornInHK;
    this.permanentVal =
      this.permanent || this.$store.state.form.applicantInfo.permanentHkid;
    this.validityPeriodVal =
      this.validityPeriod ||
      this.$store.state.form.applicantInfo.visaValidityPeriod;
    this.inviteCodeVal = this.inviteCode;
  },
  methods: {},
};
</script>
